<template>
  <div class="contentDiv">
    <div>
      <s-button @onclick="sendEmail()" label="test Mail"/>
    </div>
    <hr/>
    <!-- Begin Allopass Checkout Code -->
    <input v-model="clubId" type="text"/>
    <s-button @onclick="reinitElo" label="Reinit"/>
    <hr/>
    <s-button @onclick="testCrypto" label="Crypto"/>
    <s-button @onclick="testSchedule" label="test Schedule"/>
    <s-button @onclick="callAlloPass" label="test Allopass"/>
    <form action="https://payment.allopass.com/api/onetime/validate-codes.apu"
      method="post">
      Site_id : <input type="text" :value="site_id" name="site_id">
      Product_id : <input type="text" :value="product_id" name="product_id">
      Code : <input type="text" name="code[]" value="2621">
      Transaction_id: <input type="text" name="merchant_transaction_id" value="">
      <input type="text" value="json" name="format"/>
      <input type="submit" value="send">
      </form> 
<iframe width="770" height="550" style="max-width:100%;" 
frameborder="0" marginheight="0" marginwidth="0" scrolling="no" 
src="https://payment.allopass.com/buy/buy.apu?ids=355888&amp;idd=1552410">
</iframe>
<!-- Begin Allopass Checkout Code -->
  </div>
</template>

<script>

import firebase from "firebase"
import firebase_api from "@/firebase/firebase_api"
import cyptoJs from 'crypto-js';
export default {
    data() {
      return {
        site_id :355888,
        product_id: 1552410,
        clubId: null,
        contentSMS: "",
        to_number: ""
      }
    },
    methods: {
        sendEmail() {
             var mailRef =  firebase_api.api.getDb().collection('mail');
                mailRef.add(
                    {
                        to: "ludo.steph@gmail.com",
                        message: {
                        subject: "test",
                        html: "test"
                        },
                        group: "test"
                    }).then(()=>{console.log("bon add")})    
        },
        async reinitElo() {
           var usersDoc = await firebase_api.api.getDb().collection("user").get();
            var result = {
                nbGagnes : 0,
                nbParties: 0,
                nbTournois: 0
            }
          
            for (var userDoc in  usersDoc.docs) {
              console.log(userDoc);
              console.log(userDoc.id);
            }
          if (this.clubId=='') {
              this.clubId = null;
          }
          const functions = firebase.app().functions('europe-west1');
          const params= {
              idClub:this.clubId
          }
          functions.httpsCallable("reinitUsers")(params).then(res=>{
              console.log("REINIT OK");
          })
        },
        testCrypto() {
            var crypte = cyptoJs.AES.encrypt("ludo.steph@gmail.com", "123").toString();
            alert(crypte);
            alert(cyptoJs.AES.decrypt(crypte,"123").toString(this.CryptoJS.enc.Utf8));
        },
        async testSchedule() {
          var today = new Date();
                today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                var todayTime = today.getTime()-(5*24*3600000);
                console.log(todayTime);
                var clubDemos = 
                    await firebase_api.api.getDb().collection("club")
                        .where("demo", "==", true)
                        
                        .get();
                for (var demo in clubDemos.docs) {
                    /*var demoRef = clubDemos[demo].ref;*/
                    console.log(demo);
                    //console.log(demoRef);
                }
        },
        
        callAlloPass() {
          const functions = firebase.app().functions('europe-west1');
            const params =  {
                code: "2621",
                idTransation: "f6ba71c7-b2b8-4d51-8b7a-ab2ebc004957"
            }
            this.openWaiting = true;
            functions.httpsCallable("addCreditByAllopass")(params).then(res=>{
              console.log("COUCOU")
               console.log(res);
                // on envoie le mail
                // on dit un message comme quoi c bon
                // il peut aller les voir dans l'historique
                // i lpeut les anneuler tant que ca n'a pas été pris
            })
       },
       async call4() {
                 const code = "2621"
          const site_id = "355888";
          const product_id = "1552410";
                var params = {
                  site_id: site_id,
                  product_id: product_id,
                  "code[]": code,
                  "format": "json"
              }
                console.log("START");
                const response = await fetch('https://payment.allopass.com/api/onetime/validate-codes.apu', {
                  method: 'POST',
                  body: params, // string or object
                  headers: {
                    'Content-Type': 'application/json',
                     'Access-Control-Allow-Origin' : '*',
                     'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                  }
                });
                const myJson = await response.json(); //extract JSON from the http response
                // do something with myJson
                console.log(myJson);
        
       },
       call2() {
         const axios = require('axios');
         const instance = axios.create({
          baseURL: "http://localhost:8080",
          withCredentials: false,
          headers: {
            'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            }
        });
        // const idTransation = data.idTransation;
          const code = "2621"
          const site_id = "355888";
          const product_id = "1552410";
          var params = {
                  site_id: site_id,
                  product_id: product_id,
                  "code[]": code,
                  "format": "json"
              }
          console.log("LE CODE EST");
          console.log(code);
          console.log(site_id);
          const qs = require('qs');
          
        
          
          return instance.post('https://payment.allopass.com/api/onetime/validate-codes.apu',
              params,
              {header: {
            'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            }}
            )
            .then(response=> {
              console.log(response);
              db.collection("log").add(response);
              return response;
            })
            .catch(function(error) {
              console.log("POPO")
              console.log(error)
            })

       },
       call3() {
         // const idTransation = data.idTransation;
          const code = "2621"
          const site_id = "355888";
          const product_id = "1552410";
          var params = {
                  site_id: site_id,
                  product_id: product_id,
                  "code[]": code,
                  "format": "json"
              }
          console.log("LE CODE EST");
          console.log(code);
          console.log(site_id);
          const qs = require('qs');
          
          const axios = require('axios');
          
          return axios({
              url: 'https://payment.allopass.com/api/onetime/validate-codes.apu',
              method: 'post',
              data: params,
            })
            .then(response=> {
              console.log(response);
              db.collection("log").add(response);
              return response;
            })
            .catch(function(error) {
              console.log(error)
            })


       }
    }
}
</script>